module.exports = __webpack_public_path__ + "static/media/envalia.04209629.svg";